export default __webpack_public_path__ + "static/media/que_tal.0dee7c96.png";